export { TutorAbsentStudentLine } from "./TutorAbsentStudentLine"
export type { TutorAbsentStudentLineProps } from "./TutorAbsentStudentLine"
